/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useMemo, useRef } from "react";
import {MUITable, PaginationComponent,  BreadcrumbComponent} from "../../../common/components";
import { Checkbox } from "@mui/material";
import LeadsStatus from "../lead-qualification-leads-status";
import LeadView from "../../leads/lead-view/lead-view";
import LeadQualificationArchiveConfirmationPopups from "../lead-qualification-popups/lead-qualification-archive-confirmation-popups/lead-qualification-archive-confirmation-popups";
import "./lead-qualification-duplicate-lead.scss";
import { breadcrumbLinkDuplicateLead, getListingViewBreadcrumbLinkDuplicateLead } from "../lead-qualification-lead-list.constant";
import { getLeads } from "../../../api/lead";
import { useLogin } from "../../../common/hooks/useUser";

interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}

const LeadQualificationDuplicateLead: any  = (props: any) => {
   const {setLoading, setAlertMessage, setAlertType,  setAlertOpen, setIsShowFindDuplicates, setIsLeadQualificationMergeLeads} = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
//   const [selectedLeads, setSelectedLeads] = useState<number[]>([]);
//   const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
    const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLinkDuplicateLead(setIsShowFindDuplicates));
//   const [selectedLeadsFilter, setSelectedLeadsFilters] = useState<number[]>([]);
//   const [selectedLeadsFilterOptions, setSelectedLeadsFilterOptions] =
//     useState<any[]>(filterOptions);
//   const [selectedAllLeads, setSelectedAllLeads] = useState<any>(null);
//   const [selectedCreateLeads, setSelectedCreateLeads] = useState<any>(null);
//   const [selectedActions, setSelectedActions] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
    const [isShowConfirmArchivePopup, setIsShowConfirmArchivePopup] = useState<boolean>(false);
  const [selectedLeadId, setSelectedLeadId] = useState<any>(null);
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
    const [selectedLeadsMap, setSelectedLeadsMap] = useState<{
    [page: number]: number[];
  }>({});
  
  const userDetails = useLogin();

  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;


  const fetchLeads = async (page = 1) => {
    setLoading(true);
    try {
    const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        fetchDuplicateLeads: true
      };
      if (sortOption?.sortBy) {
        params = { ...params, ...sortOption };
      }
      const response = await getLeads(params, "Lead Details");
      setData(response.data.data.leads);
      setTotalRecords(response.data.data.totalCount);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch campaigns");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!viewOpen) {
      fetchLeads(currentPage);
    }
  }, [currentPage, isOpen, sortOption, viewOpen,]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const isAllSelected = data?.length ? selectedLeadsMap[currentPage]?.length === data?.length : false;

  const isIndeterminate =
    selectedLeadsMap[currentPage]?.length > 0 &&
    selectedLeadsMap[currentPage]?.length < data.length;

  const handleSelectAll = () => {
    if(data?.length === 0) return;
    setSelectedLeadsMap((prev) => {
      const currentPageLeads = data?.map((item) => item.id) || [];
      const selectedLeadsOnPage = prev[currentPage] || [];

      if (selectedLeadsOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageLeads };
    });
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedLeadsMap((prev) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  const headers = [
    {
      key: "select",
      label: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
      ),
    },
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    // { key: "leadCreatedBy", label: "Created By", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "lead_owner",
      leadStatus: "lead_status",
      leadCreatedBy: "created_by",
    };

    return mapping[columnName] || columnName;
  };

  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };


  const handleViewClick = async (leadId: number, leadName: string) => {
    setSelectedLeadId(leadId);

    setCrumbMappingOption(getListingViewBreadcrumbLinkDuplicateLead(setViewOpen, setSelectedLeadId, setCrumbMappingOption, leadName, setIsShowFindDuplicates)); 

    setViewOpen(true);
  };

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const middleName = item?.middle_name ? item?.middle_name?.trim() : "";

    const fullName =
      firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : firstName
          ? firstName : middleName
            ? middleName
            : lastName
              ? lastName
              : "-";
    return fullName;
  }

    const handleLeadNameUpdate = (newName: string) => {
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[3] = { ...updated[3], label: newName };
      return updated;
    });
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName} ${middleName}  ${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.owner)
        const createdBy = fetchFullName(item?.createdBy)
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
          leadCreatedBy: createdBy
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  return (
    <>
        <div className="lead-qualification-duplicate-lead-wrapper">
          <div className="breadcrumb-wrapper">
            <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
          </div>
          
          {!viewOpen ?
            <div style={{display:"block"}}>
                <div className="lead-qualification-duplicate-lead-header">
                    <div className="lead-qualification-duplicate-lead-header-title">
                        {totalRecords || 0} Duplicates Found
                    </div>
                    <div className="lead-qualification-duplicate-lead-header-subtitle">
                        We’ve identified duplicate entries. You can choose to merge them using exact or fuzzy matching for cleaner records, or archive the ones you no longer need to keep your data focused and organized.
                    </div>
                    <div className="lead-qualification-duplicate-lead-header-buttons">
                        <div>
                            <button
                                className="btn-archive-duplicates"
                                onClick={() => setIsShowConfirmArchivePopup(true)}
                                disabled={
                                        selectedLeadsMap[currentPage]?.length > 0 ? false : true
                                }
                            >
                                Archive Duplicates
                            </button>
                        </div>
                        <div>
                            <button
                                className="btn-merge-duplicates"
                                onClick={() => {
                                    setIsLeadQualificationMergeLeads(true);
                                    setIsShowFindDuplicates(false)
                                }}
                            >
                                Merge Duplicates
                            </button>
                        </div>
                    </div>
                </div>

                <div className="lead-captured-form-lead-list-table-filter">
                    <div
                        className="lead-captured-form-lead-list-table duplicate-lead-table"
                    >
                        <MUITable
                        headers={headers}
                        data={formattedData.map((item) => ({
                            key: item.id,
                            select: (
                            <Checkbox
                                checked={
                                selectedLeadsMap[currentPage]?.includes(item.id) ||
                                false
                                }
                                onClick={(event) => event.stopPropagation()}
                                onChange={() => handleCheckboxChange(item.id)}
                            />
                            ),
                            leadName: item.leadName,
                            email: item.email,
                            phone: item.phone,
                            leadSource: item.leadSource,
                            leadOwner: item.leadOwner,
                            leadCreatedBy: item.leadCreatedBy,
                            leadStatus: <LeadsStatus status={item.leadStatus} />,
                        }))}
                        onSort={handleSort}
                        noResultsTxt={"No Leads found"}
                        onRowClick={(rowData: any) => handleViewClick(rowData.key, rowData.leadName)}
                        />
                    </div>
                    {totalRecords && totalRecords > 0 ? (
                        <div className="leads-pagination-container">
                            <PaginationComponent
                            totalRecords={totalRecords}
                            pageSize={pageSize}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            />
                        </div>): null}
                </div>
            </div> :
          <LeadView
            setLoading={setLoading}
            selectedLeadId={selectedLeadId}
            onLeadNameUpdate={handleLeadNameUpdate}
          />}

          { isShowConfirmArchivePopup ?
            <LeadQualificationArchiveConfirmationPopups
              setIsShowConfirmArchivePopup={setIsShowConfirmArchivePopup}
              isShowConfirmArchivePopup={isShowConfirmArchivePopup}
                leadsIds={Object.values(selectedLeadsMap).flat() || []}
                fetchLeads={fetchLeads}
                setSelectedLeadsMap={setSelectedLeadsMap}
                totalRecords={totalRecords}
                setAlertMessage={setAlertMessage}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setLoading={setLoading}
            /> : ""}
        </div>
    </>
  );
};

export default LeadQualificationDuplicateLead;
